export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: "What is EV retrofitting?",
    answer:
      "EV retrofitting is the process of converting a suitable existing vehicle — originally powered by petrol, diesel or another fuel — into an electric vehicle. It extends the usable life of the vehicle instead of replacing it. Whether it is practical for a given vehicle is subject to technical assessment.",
  },
  {
    question: "Which vehicles can be retrofitted?",
    answer:
      "Two-wheelers, three-wheelers, passenger four-wheelers, commercial vehicles and some specialised vehicles may be considered. Suitability depends on the vehicle's condition, architecture, weight, usage and engineering assessment.",
  },
  {
    question: "Can any petrol or diesel vehicle be converted?",
    answer:
      "No. Not every vehicle is a suitable candidate. Feasibility depends on vehicle and configuration, and final viability is determined only after a technical assessment.",
  },
  {
    question: "How long does a retrofit take?",
    answer:
      "Timelines depend on the vehicle category, the retrofit configuration and workshop capacity. A schedule is shared after assessment, since configuration-dependent work cannot be estimated accurately in advance.",
  },
  {
    question: "What battery will be used?",
    answer:
      "Battery selection depends on the vehicle, weight, duty cycle, expected usage and engineering requirements. The appropriate configuration is confirmed during the assessment.",
  },
  {
    question: "What range will the vehicle provide?",
    answer:
      "Range depends on the vehicle, battery configuration, load and usage pattern. A specific range is not quoted before assessment, because it is configuration dependent.",
  },
  {
    question: "What is the retrofit cost?",
    answer:
      "Cost depends on the vehicle and the retrofit configuration, so it cannot be quoted universally. A cost estimate is provided after technical assessment of the specific vehicle.",
  },
  {
    question: "Is retrofit legally permitted?",
    answer:
      "Applicable approvals and certifications depend on the vehicle category, retrofit design and the regulations in force. Requirements may differ by vehicle type and region. Please confirm applicable requirements for your case.",
  },
  {
    question: "Is certification required?",
    answer:
      "Certification requirements depend on vehicle category, retrofit design and applicable regulations. We do not claim approval or certification for any vehicle until the applicable process has been completed for that specific retrofit.",
  },
  {
    question: "Can commercial vehicles be retrofitted?",
    answer:
      "Commercial vehicles may be evaluated for retrofit based on their route, payload and utilisation. Suitability is confirmed only after a technical assessment.",
  },
  {
    question: "Can fleets be converted?",
    answer:
      "Fleets are typically approached in phases rather than all at once. A fleet assessment reviews vehicles, routes and charging requirements to build a practical plan.",
  },
  {
    question: "Where is retrofit service available?",
    answer:
      "Service availability depends on location and workshop coverage. Share your city in an enquiry and the team will confirm what is possible for your location.",
  },
  {
    question: "How is the vehicle maintained after retrofit?",
    answer:
      "Maintenance expectations are confirmed after assessment and depend on the retrofit configuration. Serviceability is considered during the engineering phase, and maintenance guidance is shared with the completed vehicle.",
  },
];